import { PaginationControlArtists } from './pagination-control/pagination-control-artists';
import { IPanelProps } from '../interfaces/interfaces';
import { useAppSelector } from '../data/store';

/**
 * jPList bottom panel.
 */
export const BottomPanelArtists = (props: IPanelProps) => {

    const pagination = useAppSelector(store => store.pagination);

    return (
        <div className="my-10 flex items-center w-full">

            {
                pagination && pagination.pagesNumber > 1 &&
                <div className="w-full md:w-auto md:mr-4 flex justify-center md:justify-start">
                    <PaginationControlArtists/>
                </div>
            }
        </div>
    )
};